import React, { useContext, useEffect, useState, ChangeEvent, FormEvent } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import ApplyNowFormLayout from './ApplyNowFormLayout';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';
import { isFormValid } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';
import Swal from 'sweetalert2';
import JobListingService from './JobListingService';


const ApplyNowModal = () => {
    const { state, dispatch } = useContext(SmartContext);

    const handleSubmit = async (
        event: React.SyntheticEvent<HTMLButtonElement>,
        state: State,
        dispatch: (dispatchEvent: DispatchEvent) => void
    ) => {
        event.preventDefault();

        if (!isFormValid(state, dispatch)) {
            dispatch({ type: 'SHOW_ERRORS' });
            return;
        }
        console.log("formData",state?.data?.jobPostingAppliedJobs)
        const appliedJob = {
            ...state?.data?.jobPostingAppliedJobs,
            jobPostingId: state?.modalData?.data?.id  
        };

        try {
                const response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/jobs/applyNow`, appliedJob);
                console.log("response",response)
                if (response.status === 200) {
                    if(response?.data?.success){
                        console.log(response.data.message)
                        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobPostingApplyNow' } });
                        JobListingService.tabChange('APPLIED', state?.data?.summaryCounts, dispatch, state?.data?.jobPostingAppliedJobs);
                        Swal.fire({
                            title: "Done!",
                            text: response.data.message,
                            icon: "success"
                        });

                          refreshJobInList({
                            jobId: appliedJob.jobId,
                            updateFields: {
                                applied: 1
                            },
                            summaryUpdate: {
                                applied:
                                    (state.data.summaryCounts?.applied || 0) + 1
                            }
                        });
                    }
                } else {
                    console.error('Failed to save data');
                }
            } catch (error) {
                console.error('Error saving data:', error);
            }
        }

    useEffect(() => {
        dispatch({ type: 'ADD_ACTIONS', payload: { ...state.actions, SUBMIT_APPLICATION: handleSubmit } });
    }, []);
            
        const refreshJobInList = (params: {
            jobId: string;
            updateFields: any;
            summaryUpdate?: any;
        }) => {
            const jobs = state?.data?.filteredData;
            if (!jobs?.length) return;

            const modifiedJobs = jobs.map((job: any) =>
                job.id === params.jobId
                    ? { ...job, ...params.updateFields }
                    : job
            );

            dispatch({
                type: 'REFRESH_DATA',
                payload: {
                    data: {
                        ...state.data,
                        filteredData: modifiedJobs,
                        summaryCounts: {
                            ...state.data.summaryCounts,
                            ...(params.summaryUpdate || {})
                        }
                    }
                }
            });
        };

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <ApplyNowFormLayout>{!state.flags.isDataLoading && <PageBuilder />}</ApplyNowFormLayout>
        </SmartContext.Provider>
    );
};

export default ApplyNowModal;
